import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { useMediaQuery } from "react-responsive";
import BurgerItem from "./BurgerItem";
import { useI18n } from "../../i18n/I18nContext";

function BurgerList({ innerRef }) {
  const { t, translations } = useI18n();
  const translatedBurgerTypeList = translations.burgers;
  // const [selectedBurgerId, setSelectedBurgerId] = useState(-1)

  const SelectBurgerItem = (itemId) => {
    if (isMobile) {
      setOpenBurgersId((openBurgers) => {
        //ako je otvoren, zatvarmao ga
        if (isSelected(itemId)) {
          return openBurgersId.filter((element, index) => {
            if (element != itemId) return true;
          });
        }

        //ako dodajemo element, odnosno otvaramo dodatni akordion
        return [...openBurgers, itemId];
      });
    } else {
      setOpenBurgersId([itemId]);
    }
  };
  const isSelected = (id) => {
    for (let i of openBurgersId) {
      if (i == id) return true;
    }

    return false;
  };
  //za mobilni, vise selektovanih
  const [openBurgersId, setOpenBurgersId] = useState([]);

  // const isMobile = false

  const isMobile = useMediaQuery({ query: "(max-width:576px)" });

  const [loaded, setLoaded] = useState(false);

  const [ref, inView, entry] = useInView({
    threshold: 0.3,
  });

  useEffect(() => {
    if (!loaded) {
      if (inView) {
        setLoaded(true);
      }
    } else {
    }
  }, [inView]);
  return (
    <>
      <section
        className={`burger-list-section ${loaded ? "fade-in" : ""}`}
        ref={ref}
        id="burger-list"
      >
        <h1>{t("burgersSection.heading")}</h1>

        {/* Flex wrapper */}
        <div className="burger-list-section-content">
          {/* List of burgers on the left side */}
          <div className="burger-list-container">
            {/* Single row of burgers */}
            {translatedBurgerTypeList.map((burger, index) => {
              //da li je selektovan item, drugacije u zavisnosti da li je mobilni ili ne

              return (
                <BurgerItem
                  key={burger.id}
                  id={burger.id}
                  name={burger.name}
                  ingredients={burger.ingredients}
                  bestBuy={burger.bestBuy}
                  image={burger.image}
                  selected={isSelected(burger.id)}
                  SelectBurgerItem={SelectBurgerItem}
                  keyIngredient={burger.keyIngredient}
                  keyIngredientImage={burger.keyIngredientImage}
                  isMobile={isMobile}
                ></BurgerItem>
              );
            })}
          </div>
          {/* Burger on the right side which jumps into */}

          {isMobile
            ? ""
            : translatedBurgerTypeList.map((burger, index) => {
                return (
                  <div
                    key={burger.id}
                    className={`${
                      isSelected(burger.id) ? "show " : ""
                    }big-burger-right-container`}
                  >
                    <div className="burger-img-wrapper">
                      {/* <LazyLoadImage src={burger.image}></LazyLoadImage> */}
                      <img src={burger.image} alt={t("alt.burger")} />
                    </div>
                    <div className="burger-ingredients-container">
                      <h5>{t("burgersSection.ingredientsLabel")}</h5>
                      <p>{burger.ingredients}</p>
                      {/* 100% beef and other characteristic */}
                      <div className="burger-characteristic">
                        <div className="single-burger-characteristic">
                          <div className="beef-img-wrapper">
                            <img src="images/kravica.webp" alt={t("alt.cow")} />
                          </div>
                          <p>{t("burgersSection.beefLabel")}</p>
                        </div>
                        <div className="single-burger-characteristic">
                          <div className="beef-img-wrapper">
                            {true ? (
                              <img
                                src={burger.keyIngredientImage}
                                alt={t("alt.ingredient")}
                              />
                            ) : (
                              <img
                                src={burger.keyIngredientImage}
                                alt={t("alt.ingredient")}
                              />
                            )}
                          </div>
                          {true ? (
                            <p>{burger.keyIngredient}</p>
                          ) : (
                            <p>{burger.keyIngredient}</p>
                          )}
                        </div>
                      </div>

                      {/* <h6>
                        Već od <span>{burger.sizes[0].price} dinara</span>{' '}
                      </h6> */}
                    </div>
                  </div>
                );
              })}
        </div>

        <div
          className="full-menu-pointer"
          onClick={() => {
            // window.location('#meni')

            var meni = document.getElementById("meni");

            // meni.scrollIntoView()
            window.scrollTo(0, meni.offsetTop - 80);
            // window.scrollBy(0, 200)
          }}
        >
          <div className="wrapper">
            <img src="images/down-arrow.webp" alt={t("alt.downArrow")} />
          </div>
          <p>{t("burgersSection.fullMenu")}</p>
        </div>
      </section>
    </>
  );
}

export default BurgerList;
